import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import AboutAdmin from './AboutAdmin';
import HeaderAdmin from './HeaderAdmin';
import HomeAdmin from './homeAdmin';
import InputTransaksiDonasi from './InputTransaksiDonasi';
import KonfirmasiDonasiAdmin from './KonfirmasiDonasiAdmin';
import LaporanDonasiAdmin from './LaporanDonasiAdmin';
import ManajemenKonten from './manajemen_kontenAdmin';
import ListDonatur from './list_donaturAdmin';
import InputPenyaluranAdmin from './InputPenyaluranAdmin';
import ListPenyaluranAdmin from './ListPenyaluranAdmin';
import ListPengajuanAdmin from './ListPengajuanAdmin';
import RiwayatPengajuanPage from './riwayat_pengajuan';
import NotifikasiManager from './NotifikasiAdmin';
import PenerimaManfaatAdmin from './PenerimaManfaatAdmin';
import PengeluaranAdmin from './PengeluaranAdmin';
import QrisAdmin from './QrisAdmin';
import JenisBebanAdmin from './JenisBebanAdmin';
import { canAccessAdminRoute } from './roleAdmin';
import SidebarAdmin from './sidebarAdmin';

function AccessDenied() {
  return (
    <div className="min-h-screen bg-slate-50 px-6 py-12 lg:px-16">
      <div className="rounded-lg border border-amber-200 bg-amber-50 p-6 text-amber-800">
        <p className="text-sm font-semibold uppercase tracking-wide">Akses Ditolak</p>
        <h1 className="mt-2 text-2xl font-bold text-slate-900">Halaman ini tidak tersedia untuk role Anda.</h1>
        <p className="mt-3 text-sm leading-6">
          Silakan gunakan menu yang tersedia di sidebar sesuai hak akses akun admin yang sedang login.
        </p>
      </div>
    </div>
  );
}

function RoutesAdmin({ admin, onLogout }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const guard = (routeKey, element) => (canAccessAdminRoute(admin, routeKey) ? element : <AccessDenied />);

  return (
    <>
      <HeaderAdmin
        admin={admin}
        onLogout={onLogout}
        onToggleSidebar={() => setIsSidebarOpen((prev) => !prev)}
      />

      <SidebarAdmin isOpen={isSidebarOpen} admin={admin}>
        <Routes>
          <Route path="/" element={guard('dashboard', <HomeAdmin admin={admin} />)} />
          <Route path="/list/donatur" element={guard('listDonatur', <ListDonatur admin={admin} />)} />
          <Route path="/admin/input-transaksi" element={guard('inputTransaksi', <InputTransaksiDonasi admin={admin} />)} />
          <Route path="/konfirmasi/donasi" element={guard('konfirmasiDonasi', <KonfirmasiDonasiAdmin admin={admin} />)} />
          <Route path="/laporan/donasi" element={guard('laporanDonasi', <LaporanDonasiAdmin admin={admin} />)} />
          <Route path="/pengeluaran" element={guard('pengeluaran', <PengeluaranAdmin admin={admin} />)} />
          <Route path="/pengeluaran/jenis-beban" element={guard('jenisBeban', <JenisBebanAdmin admin={admin} />)} />
          <Route path="/transaksi/qrcode" element={guard('qrCode', <QrisAdmin admin={admin} />)} />
          <Route path="/penyaluran/list" element={guard('listPenyaluran', <ListPenyaluranAdmin admin={admin} />)} />
          <Route path="/penyaluran/input" element={guard('inputPenyaluran', <InputPenyaluranAdmin admin={admin} />)} />
          <Route path="/penyaluran/penerima-manfaat" element={guard('penerimaManfaat', <PenerimaManfaatAdmin />)} />
          <Route path="/pengajuan/riwayat" element={guard('pengajuan', <ListPengajuanAdmin admin={admin} />)} />
          <Route path="/pengajuan/riwayat/:id" element={guard('pengajuan', <RiwayatPengajuanPage admin={admin} />)} />
          <Route path="/manajemen-konten" element={guard('manajemenKonten', <ManajemenKonten admin={admin} />)} />
          <Route path="/notifikasi" element={guard('notifikasi', <NotifikasiManager />)} />
          <Route path="/about" element={guard('about', <AboutAdmin />)} />
          <Route path="*" element={<AccessDenied />} />
        </Routes>
      </SidebarAdmin>
    </>
  );
}

export default RoutesAdmin;
